import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useLocation } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  getDeptInfoById,
  getCrewsWithNoDept,
  affecterEquipeToDept,
  getAllDepts,
  updateCrewDept,
  DeleteCrewDept,
} from "../../../../services/RHService/DepartementService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const CrewbyDepartment = () => {
  const location = useLocation();
  const idDept = new URLSearchParams(location.search).get("idDept");

  //variables
  const Swal = require("sweetalert2");
  const [showModifyform, setShowModifyform] = useState(false);
  const handleCloseModifyform = () => setShowModifyform(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [deptDetails, setDeptDetails] = useState();
  const [crews, setCrews] = useState([]);
  const [formData, setFormData] = useState({});
  const [crewError, setCrewError] = useState("");
  const [selectedCrew, setSelectedCrew] = useState([]);
  const [dept, setDept] = useState([]);

  useEffect(() => {
    getCrewsWithNoDept(getCurrentUserId())
      .then((n) => {
        setCrews(n.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const handleInputChange = async (event) => {
    try {
      const target = event.target;
      const name = target.name;
      const value = target.type === "checkbox" ? target.checked : target.value;
      setFormData({ ...formData, [name]: value });
    } catch (error) {
      console.error(error);
    }
  };
  const fetchData = async () => {
    const response = await getDeptInfoById(idDept);

    setDeptDetails(response.data);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (idEquipe) => {
    await DeleteCrewDept(idEquipe, setDeptDetails, deptDetails);
  };
  const handleShowModifyform = (crew) => {
    setSelectedCrew(crew);
    setShowModifyform(true);
  };
  //colonnes de tableau
  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    { dataField: "nomEquipe", text: "Nom d'équipe" },
    {
      dataField: "chefequipe",
      text: "Chef d'équipe",
      formatter: (cell, row) => `${row.firstname} ${row.lastname}`,
    },
    { dataField: "phone", text: "Mobile" },
    { dataField: "email", text: "Email" },
    { dataField: "nbEmployeeByCrew", text: "Nombre d'employé" },
    {
      dataField: "actions",
      text: "Actions",
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <div className="center" style={{ display: "flex" }}>
            <Button
              className="mx-2"
              style={{
                "background-color": "#000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleShowModifyform(row);
              }}
            >
              <i className="fa-solid fa-pencil"></i>
            </Button>

            <Button
              style={{
                "background-color": "#cc0000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleDelete(row.idEquipe);
              }}
            >
              <i className="fa-solid fa-trash-can"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  //affectation
  const handleSubmit = async (event) => {
    event.preventDefault();

    const { idEquipe } = formData;
    let hasError = false;

    if (!idEquipe || idEquipe === "equipe") {
      setCrewError("Veuillez saisir une équipe.");
      hasError = true;
    } else {
      setCrewError("");
    }
    if (!hasError) {
      try {
        await affecterEquipeToDept(idDept, formData);
        toastr.success("Equipe affecté avec succès.");
        handleClose(true);
      } catch (error) {
        toastr.error("Erreur lors de l'affectation.");
      }
    }
  };
  const fetchDepts = async () => {
    try {
      const names = await getAllDepts(getCurrentUserId());
      if (names.status === 200) {
        setDept(names.data?.success);
      } else if (names.error) {
        throw new Error(names.error);
      }
    } catch (error) {
      console.error(`Failed to fetch dept names: ${error}`);
    }
  };
  useEffect(() => {
    fetchDepts();
  }, []);

  const handleUpdate = async (event) => {
    event.preventDefault();

    if (!selectedCrew.idDept || selectedCrew.idDept === 0) {
      setCrewError("Veuillez saisir une departement");
    } else {
      setCrewError("");
      try {
        await updateCrewDept(selectedCrew.idEquipe, selectedCrew);
        fetchData();
        handleCloseModifyform();
      } catch (error) {
        alert(error.message);
      }
    }
  };
  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider keyField="id" columns={columns}>
        {(props) => (
          <div>
            {/* Modal d'affectation d'un personnel a une equipe */}
            <Modal
              show={showModifyform}
              onHide={handleCloseModifyform}
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Modifier la département de l'équipe</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <Form.Group className="form-group">
                          <label>Equipe </label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            disabled
                            name="idEquipe"
                            onChange={(e) =>
                              setSelectedCrew({
                                ...selectedCrew,
                                idEquipe: e.target.value,
                              })
                            }
                            value={selectedCrew ? selectedCrew.nomEquipe : ""}
                          />
                        </Form.Group>

                        <Form.Group className="form-group">
                          <label for="exampleSelectBorder">Département </label>
                          <select
                            className="custom-select form-control-border"
                            name="idDept"
                            value={selectedCrew ? selectedCrew.idDept : 0}
                            onChange={(e) =>
                              setSelectedCrew({
                                ...selectedCrew,
                                idDept: e.target.value,
                              })
                            }
                          >
                            {dept.map((dep) => (
                              <option key={dep.idDept} value={dep.idDept}>
                                {dep.nomDept}
                              </option>
                            ))}
                          </select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModifyform}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modal d'affectation d'un personnel a une equipe */}
            {/* header */}

            {/* Modal d'affectation d'une equipe a une dept */}
            <Modal show={show} onHide={handleClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Ajouter une equipe à une département</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleSubmit}>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <div className="form-group">
                          <label>Equipe </label>
                          <select
                            className="custom-select form-control-border"
                            name="idEquipe"
                            value={formData.idEquipe || ""}
                            onChange={handleInputChange}
                          >
                            <option value="equipe">
                              --Choisir une Equipe--
                            </option>
                            {crews.map((crew) => (
                              <option key={crew.id} value={crew.id}>
                                {crew.nomEquipe}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleSubmit}>
                  Ajouter
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1 className="m-0">Liste des équipes</h1>
                  </div>
                  <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                      <li className="breadcrumb-item">
                        <i class="fa-solid fa-house"></i>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/crewList">Liste des départements</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {deptDetails ? deptDetails.nomDept : ""}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* body */}
            <div class="container-fluid">
              <div class="row">
                <div className="col-md-12 col-lg-12 col-sm-12 mb-2">
                  <button
                    type="button"
                    style={{ width: "max-content", color: "white" }}
                    className="btn btn-default bg2 float-right"
                    onClick={handleShow}
                  >
                    Ajouter Equipe
                  </button>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div className="col-md-3">
                          <strong className="center">Nom de département</strong>
                          <br></br>
                          {deptDetails ? deptDetails.nomDept : ""}
                        </div>
                        <div className="col-md-3">
                          <strong className="center">
                            Chef de département
                          </strong>
                          <br></br>
                          {deptDetails
                            ? deptDetails.firstname + " " + deptDetails.lastname
                            : ""}{" "}
                        </div>

                        <div className="col-md-3">
                          <strong className="center">Email</strong>
                          <br></br>
                          {deptDetails ? deptDetails.email : ""}{" "}
                        </div>
                        <div className="col-md-3">
                          <strong className="center">Nombre d'équipe</strong>
                          <br></br>
                          {deptDetails ? deptDetails.nbEquipeByDept : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      {/* table */}
                      <BootstrapTable
                        {...props.baseProps}
                        data={deptDetails ? deptDetails.crews : ""}
                        columns={columns}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default CrewbyDepartment;
